/**
 * API response types for dashboardOrderHknVolume.
 */
export interface HknTypeAmounts {
  contractAmount: number;
  closedAmount: number;
  deliveryClosedAmount: number;
  deliveryOpenAmount: number;
  openAmount: number;
}

export interface PositionValuesByType {
  key: string;
  value: HknTypeAmounts;
}

export interface ValuesByYear {
  deliveryYear: number;
  positionValuesByType: PositionValuesByType[];
  totalAmount: number;
}

export interface DashboardOrderHknVolumeItem {
  id: number;
  name: string;
  valuesByYear: ValuesByYear[];
}

export interface DashboardOrderHknVolumeAppliedFilters {
  marketAreaName: string | null;
  deliveryAreaName: string | null;
  segmentName: string | null;
  kamNames: string[];
  companyNames: string[];
  hknTypeNames: string[];
  years: number[];
  tradeDateFrom: string | Date | null;
  tradeDateTo: string | Date | null;
}

/**
 * View model for the HKN customers table.
 * - customers: raw API items.
 * - appliedFilters: normalized legend data for the current widget filter.
 */
export interface MarketHknCustomersTableViewModel {
  customers: DashboardOrderHknVolumeItem[];
  appliedFilters: DashboardOrderHknVolumeAppliedFilters;
}

/**
 * Builds the table view model.
 */
export function buildMarketHknCustomersTableViewModel(
  customers: DashboardOrderHknVolumeItem[],
  appliedFilters: DashboardOrderHknVolumeAppliedFilters,
): MarketHknCustomersTableViewModel {
  return { customers, appliedFilters };
}

/**
 * Returns total amount for an HKN type (open + closed).
 */
export function getTypeTotal(amounts: HknTypeAmounts): number {
  return amounts.openAmount + amounts.closedAmount;
}
